/* eslint-disable */
export default {
  removeMeetingWarning:
    'La fonctionnalité de planification a été supprimée. Veuillez utiliser {app} pour planifier vos réunions vidéo.',
  scheduleMeetingTips:
    'Remarque : nous avons supprimé les réunions de cette application. Pour utiliser les fonctions de réunion, nous vous recommandons d’utiliser {app}.',
  migrateToPluginAlert:
    'Remarque : cette application ne fonctionnera pas avec les versions Outlook 2016 et inférieures et avec Internet Explorer 11. Mettez à niveau votre version Outlook ou bien passez à Microsoft Edge ou à {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
